module.exports = __webpack_public_path__ + "static/media/ic_Quiz-Correct.fd620b6c.png";